/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import httpService from '@/core/http/http.service';
import serverContextStore from '@/shared/content/server-context.store';
import { AxiosRequestConfig } from 'axios';

export class B2BClient {

    requestAccess(request: RequestAccessRequest, messageId?: string): Promise<ClientResponseOfRequestAccessResult> {
        let apiPathAndParams = '/api/b2b/request-access';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfRequestAccessResult>(apiUrl, request, messageId);
    }
    getPartnerProfile(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPartnerProfileInformation> {
        let apiPathAndParams = '/api/b2b/profile';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPartnerProfileInformation>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/profile-' + cancellationContextKey : undefined);
    }
    getExchangeRate(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfExchangeRateModel> {
        let apiPathAndParams = '/api/b2b/profile/exchange-rate';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfExchangeRateModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/profile/exchange-rate-' + cancellationContextKey : undefined);
    }
    setExchangeRate(exchangeRate: ExchangeRate, messageId?: string): Promise<ClientResponseOfExchangeRateModel> {
        let apiPathAndParams = '/api/b2b/profile/exchange-rate';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfExchangeRateModel>(apiUrl, exchangeRate, messageId);
    }
    getPartnerUsersList(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIEnumerableOfPartnerUser> {
        let apiPathAndParams = '/api/b2b/profile/users';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIEnumerableOfPartnerUser>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/profile/users-' + cancellationContextKey : undefined);
    }
    deletePartnerUser(contactId: string | null, messageId?: string): Promise<ClientResponseOfIEnumerableOfPartnerUser> {
        let apiPathAndParams = '/api/b2b/profile/users/{contactId}';
        if (contactId === undefined || contactId === null)
            throw new Error('The parameter "contactId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{contactId}', encodeURIComponent('' + contactId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfIEnumerableOfPartnerUser>(apiUrl, messageId);
    }
    changePartnerUserRole(contactId: string | null, role: B2BContactUserRole, messageId?: string): Promise<ClientResponseOfIEnumerableOfPartnerUser> {
        let apiPathAndParams = '/api/b2b/profile/users/{contactId}/role/{role}';
        if (contactId === undefined || contactId === null)
            throw new Error('The parameter "contactId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{contactId}', encodeURIComponent('' + contactId));
        if (role === undefined || role === null)
            throw new Error('The parameter "role" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{role}', encodeURIComponent('' + role));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfIEnumerableOfPartnerUser>(apiUrl, messageId);
    }
    resetPartnerUserPassword(contactId: string | null, request: B2BPasswordResetTokenRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2b/profile/users/{contactId}/password/reset-token';
        if (contactId === undefined || contactId === null)
            throw new Error('The parameter "contactId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{contactId}', encodeURIComponent('' + contactId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    changeUserPassword(request: ChangePasswordRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2b/profile/password';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    getDeliveryAddresses(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPartnerAddressOf> {
        let apiPathAndParams = '/api/b2b/profile/delivery-addresses';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPartnerAddressOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/profile/delivery-addresses-' + cancellationContextKey : undefined);
    }
    resetPassword(request: ChangePasswordFromTokenRequest, messageId?: string): Promise<ClientResponseOfValidateTokenResult> {
        let apiPathAndParams = '/api/b2b/password/reset';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfValidateTokenResult>(apiUrl, request, messageId);
    }
    resetPasswordTokenByEmail(request: B2BResetPasswordTokenByUsernameRequest, messageId?: string): Promise<string> {
        let apiPathAndParams = '/api/b2b/password/reset-token';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<string>(apiUrl, request, messageId);
    }
    validateResetToken(request: ValidateTokenRequest, messageId?: string): Promise<ClientResponseOfValidateTokenResult> {
        let apiPathAndParams = '/api/b2b/password/validate-token';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfValidateTokenResult>(apiUrl, request, messageId);
    }
    getPartnerProductPrices(sku: string[] | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfDictionaryOfStringAndProductPriceModel> {
        let apiPathAndParams = '/api/b2b/product/price?';
        if (sku !== undefined && sku !== null)
            sku && sku.forEach(item => { apiPathAndParams += 'sku=' + encodeURIComponent('' + item) + '&'; });
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDictionaryOfStringAndProductPriceModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/product/price-' + cancellationContextKey : undefined);
    }
    getPartnerModulePrice(modules: Module[] | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfProductPriceModel> {
        let apiPathAndParams = '/api/b2b/product/modules-price?';
        if (modules !== undefined && modules !== null)
            modules && modules.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				apiPathAndParams += 'modules[' + index + '].' + attr + '=' + encodeURIComponent('' + (<any>item)[attr]) + '&';
        			}
            });
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductPriceModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/product/modules-price-' + cancellationContextKey : undefined);
    }
    getOrders(term: string | null | undefined, orderStatus: FilterSalesStatus | null | undefined, from: Date | null | undefined, to: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPaginatedResult> {
        let apiPathAndParams = '/api/b2b/orders?';
        if (term !== undefined && term !== null)
            apiPathAndParams += 'term=' + encodeURIComponent('' + term) + '&';
        if (orderStatus !== undefined && orderStatus !== null)
            apiPathAndParams += 'orderStatus=' + encodeURIComponent('' + orderStatus) + '&';
        if (from !== undefined && from !== null)
            apiPathAndParams += 'from=' + encodeURIComponent(from ? '' + from.toJSON() : '') + '&';
        if (to !== undefined && to !== null)
            apiPathAndParams += 'to=' + encodeURIComponent(to ? '' + to.toJSON() : '') + '&';
        if (pageNumber !== undefined && pageNumber !== null)
            apiPathAndParams += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
        if (pageSize !== undefined && pageSize !== null)
            apiPathAndParams += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPaginatedResult>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/orders-' + cancellationContextKey : undefined);
    }
    getOrder(orderNumber: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfOrder> {
        let apiPathAndParams = '/api/b2b/orders/order/{orderNumber}';
        if (orderNumber === undefined || orderNumber === null)
            throw new Error('The parameter "orderNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{orderNumber}', encodeURIComponent('' + orderNumber));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfOrder>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/orders/order/{orderNumber}-' + cancellationContextKey : undefined);
    }
    getOrderConfirmationPdf(orderNumber: string | null | undefined, orderConfirmationId: string | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<FileResponse> {
        let apiPathAndParams = '/api/b2b/orders/orderconfirmation?';
        if (orderNumber !== undefined && orderNumber !== null)
            apiPathAndParams += 'orderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (orderConfirmationId !== undefined && orderConfirmationId !== null)
            apiPathAndParams += 'orderConfirmationId=' + encodeURIComponent('' + orderConfirmationId) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<FileResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/orders/orderconfirmation-' + cancellationContextKey : undefined);
    }
    getInvoicePdf(orderNumber: string | null | undefined, invoiceNumber: string | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<FileResponse> {
        let apiPathAndParams = '/api/b2b/orders/invoice?';
        if (orderNumber !== undefined && orderNumber !== null)
            apiPathAndParams += 'orderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            apiPathAndParams += 'invoiceNumber=' + encodeURIComponent('' + invoiceNumber) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<FileResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/orders/invoice-' + cancellationContextKey : undefined);
    }
    getTransactions(term: string | null | undefined, all: boolean | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortByDirection: OrderByDirection | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfGetTransactionsResponse> {
        let apiPathAndParams = '/api/b2b/finance/transactions?';
        if (term !== undefined && term !== null)
            apiPathAndParams += 'Term=' + encodeURIComponent('' + term) + '&';
        if (all === null)
            throw new Error('The parameter "all" cannot be null.');
        else if (all !== undefined)
            apiPathAndParams += 'All=' + encodeURIComponent('' + all) + '&';
        if (startDate !== undefined && startDate !== null)
            apiPathAndParams += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate !== undefined && endDate !== null)
            apiPathAndParams += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (pageNumber === null)
            throw new Error('The parameter "pageNumber" cannot be null.');
        else if (pageNumber !== undefined)
            apiPathAndParams += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
        if (pageSize === null)
            throw new Error('The parameter "pageSize" cannot be null.');
        else if (pageSize !== undefined)
            apiPathAndParams += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (sortBy !== undefined && sortBy !== null)
            apiPathAndParams += 'SortBy=' + encodeURIComponent('' + sortBy) + '&';
        if (sortByDirection === null)
            throw new Error('The parameter "sortByDirection" cannot be null.');
        else if (sortByDirection !== undefined)
            apiPathAndParams += 'SortByDirection=' + encodeURIComponent('' + sortByDirection) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfGetTransactionsResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/finance/transactions-' + cancellationContextKey : undefined);
    }
    getTransactionPdfDocument(orderNumber: string | null | undefined, invoiceNumber: string | null | undefined, requisitionStatus: TransactionStatus | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<FileResponse> {
        let apiPathAndParams = '/api/b2b/finance/transactions/downloadDocument?';
        if (orderNumber !== undefined && orderNumber !== null)
            apiPathAndParams += 'orderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            apiPathAndParams += 'invoiceNumber=' + encodeURIComponent('' + invoiceNumber) + '&';
        if (requisitionStatus === null)
            throw new Error('The parameter "requisitionStatus" cannot be null.');
        else if (requisitionStatus !== undefined)
            apiPathAndParams += 'requisitionStatus=' + encodeURIComponent('' + requisitionStatus) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<FileResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/finance/transactions/downloadDocument-' + cancellationContextKey : undefined);
    }
    getPartnerBalance(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPartnerBalance> {
        let apiPathAndParams = '/api/b2b/finance/partnerBalance';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPartnerBalance>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/finance/partnerBalance-' + cancellationContextKey : undefined);
    }
    getAllFavorites(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIEnumerableOfFavorite> {
        let apiPathAndParams = '/api/b2b/favorites';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIEnumerableOfFavorite>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/favorites-' + cancellationContextKey : undefined);
    }
    createFavorite(createFavoriteRequest: CreateFavoriteRequest, messageId?: string): Promise<ClientResponseOfIEnumerableOfFavorite> {
        let apiPathAndParams = '/api/b2b/favorites';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfIEnumerableOfFavorite>(apiUrl, createFavoriteRequest, messageId);
    }
    getFavorite(favoriteId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfFavorite> {
        let apiPathAndParams = '/api/b2b/favorites/favorite/{favoriteId}';
        if (favoriteId === undefined || favoriteId === null)
            throw new Error('The parameter "favoriteId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteId}', encodeURIComponent('' + favoriteId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfFavorite>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/favorites/favorite/{favoriteId}-' + cancellationContextKey : undefined);
    }
    updateFavorite(favoriteId: number, updateFavoriteRequest: UpdateFavoriteRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2b/favorites/favorite/{favoriteId}';
        if (favoriteId === undefined || favoriteId === null)
            throw new Error('The parameter "favoriteId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteId}', encodeURIComponent('' + favoriteId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponse>(apiUrl, updateFavoriteRequest, messageId);
    }
    deleteFavorite(favoriteId: number, messageId?: string): Promise<ClientResponseOfIEnumerableOfFavorite> {
        let apiPathAndParams = '/api/b2b/favorites/favorite/{favoriteId}';
        if (favoriteId === undefined || favoriteId === null)
            throw new Error('The parameter "favoriteId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteId}', encodeURIComponent('' + favoriteId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfIEnumerableOfFavorite>(apiUrl, messageId);
    }
    createFavoriteItem(favoriteId: number, createFavoriteItemRequest: CreateFavoriteItemRequest, messageId?: string): Promise<ClientResponseOfFavorite> {
        let apiPathAndParams = '/api/b2b/favorites/favorite/{favoriteId}/favoriteItem';
        if (favoriteId === undefined || favoriteId === null)
            throw new Error('The parameter "favoriteId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteId}', encodeURIComponent('' + favoriteId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfFavorite>(apiUrl, createFavoriteItemRequest, messageId);
    }
    updateFavoriteItem(favoriteId: number, favoriteItemId: number, updateFavoriteItemRequest: Request, messageId?: string): Promise<ClientResponseOfFavorite> {
        let apiPathAndParams = '/api/b2b/favorites/favorite/{favoriteId}/favoriteItem/{favoriteItemId}';
        if (favoriteId === undefined || favoriteId === null)
            throw new Error('The parameter "favoriteId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteId}', encodeURIComponent('' + favoriteId));
        if (favoriteItemId === undefined || favoriteItemId === null)
            throw new Error('The parameter "favoriteItemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteItemId}', encodeURIComponent('' + favoriteItemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfFavorite>(apiUrl, updateFavoriteItemRequest, messageId);
    }
    deleteFavoriteItem(favoriteId: number, favoriteItemId: number, messageId?: string): Promise<ClientResponseOfFavorite> {
        let apiPathAndParams = '/api/b2b/favorites/favorite/{favoriteId}/favoriteItem/{favoriteItemId}';
        if (favoriteId === undefined || favoriteId === null)
            throw new Error('The parameter "favoriteId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteId}', encodeURIComponent('' + favoriteId));
        if (favoriteItemId === undefined || favoriteItemId === null)
            throw new Error('The parameter "favoriteItemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteItemId}', encodeURIComponent('' + favoriteItemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfFavorite>(apiUrl, messageId);
    }
    getFavoriteEarliestAvailabilityDates(favoriteId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIEnumerableOfFavoriteItemAvailabilityDate> {
        let apiPathAndParams = '/api/b2b/favorites/favorite/{favoriteId}/earliestAvailabilityDates';
        if (favoriteId === undefined || favoriteId === null)
            throw new Error('The parameter "favoriteId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{favoriteId}', encodeURIComponent('' + favoriteId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIEnumerableOfFavoriteItemAvailabilityDate>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/favorites/favorite/{favoriteId}/earliestAvailabilityDates-' + cancellationContextKey : undefined);
    }
    getSharedFavorite(sharedIdentifier: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfSharedFavorite> {
        let apiPathAndParams = '/api/b2b/favorites/shared/{sharedIdentifier}';
        if (sharedIdentifier === undefined || sharedIdentifier === null)
            throw new Error('The parameter "sharedIdentifier" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sharedIdentifier}', encodeURIComponent('' + sharedIdentifier));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfSharedFavorite>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/favorites/shared/{sharedIdentifier}-' + cancellationContextKey : undefined);
    }
    uploadClaimFormFile(file: FileParameter | null | undefined, messageId?: string): Promise<ClientResponseOfUploadClaimFormFileResponse> {
        let apiPathAndParams = '/api/b2b/claimform/upload-file';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfUploadClaimFormFileResponse>(apiUrl, messageId);
    }
    createClaim(request: CreateClaimsRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2b/claimform';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    initializePayment(basketId: string | null, messageId?: string): Promise<ClientResponseOfPaymentInitializeResult> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPaymentInitializeResult>(apiUrl, messageId);
    }
    submitOrderWithB2BPayment(basketId: string | null, messageId?: string): Promise<ClientResponseOfPaymentFinalizeResult> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/payment/b2b-payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPaymentFinalizeResult>(apiUrl, messageId);
    }
    initializeAltaPayPayment(basketId: string | null, initializeAltaPayPaymentRequest: InitializeAltaPayPaymentRequest, messageId?: string): Promise<ClientResponseOfAltaPayPaymentInitializeResult> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/payment/alta-pay/initialize-payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfAltaPayPaymentInitializeResult>(apiUrl, initializeAltaPayPaymentRequest, messageId);
    }
    finalizeAltaPayPayment(basketId: string | null, finalizePaymentRequest: FinalizeAltaPayPaymentRequest, messageId?: string): Promise<ClientResponseOfPaymentFinalizeResult> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/payment/alta-pay/finalize-payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPaymentFinalizeResult>(apiUrl, finalizePaymentRequest, messageId);
    }
    getBasketForCheckOut(basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketCheckoutModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/check-out-' + cancellationContextKey : undefined);
    }
    setDeliveryAddress(basketId: string | null, addressId: string | null, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/delivery/delivery-address/{addressId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (addressId === undefined || addressId === null)
            throw new Error('The parameter "addressId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{addressId}', encodeURIComponent('' + addressId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    setDeliveryTime(basketId: string | null, deliveryId: number, deliveryTimeRequest: SetDeliveryTimeRequest, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-time';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, deliveryTimeRequest, messageId);
    }
    splitDelivery(basketId: string | null, deliveryId: number, itemIds: number[], messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/delivery/{deliveryId}/split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, itemIds, messageId);
    }
    removeSplitDelivery(basketId: string | null, deliveryId: number, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/delivery/{deliveryId}/split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    removeSplitDeliveries(basketId: string | null, deliveryId: number, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/check-out/delivery/{deliveryId}/remove-split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    getBasket(basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}-' + cancellationContextKey : undefined);
    }
    deleteBasket(basketId: string | null, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    addRegularItem(basketId: string | null, request: AddBasketItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/regular';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addPickAndPackItem(basketId: string | null, request: AddBasketItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/pick-and-pack';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addModuleSofaItem(basketId: string | null, request: AddModuleSofaRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/module-sofa';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    updateModuleSofaItem(basketId: string | null, moduleSofaReferenceId: string, request: AddModuleSofaRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/module-sofa/{moduleSofaReferenceId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleSofaReferenceId === undefined || moduleSofaReferenceId === null)
            throw new Error('The parameter "moduleSofaReferenceId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleSofaReferenceId}', encodeURIComponent('' + moduleSofaReferenceId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getModuleSofaItem(basketId: string | null, moduleSofaReferenceId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfModuleSofaConfigurationProductItem> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/module-sofa/{moduleSofaReferenceId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleSofaReferenceId === undefined || moduleSofaReferenceId === null)
            throw new Error('The parameter "moduleSofaReferenceId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleSofaReferenceId}', encodeURIComponent('' + moduleSofaReferenceId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfModuleSofaConfigurationProductItem>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/module-sofa/{moduleSofaReferenceId}-' + cancellationContextKey : undefined);
    }
    addOrUpdateModuleConfiguration(basketId: string | null, moduleConfigurationId: string, request: AddOrUpdateModuleConfigurationRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/module-configuration/{moduleConfigurationId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleConfigurationId === undefined || moduleConfigurationId === null)
            throw new Error('The parameter "moduleConfigurationId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleConfigurationId}', encodeURIComponent('' + moduleConfigurationId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    updateItemQuantity(basketId: string | null, itemId: number, request: UpdateItemQuantityRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    deleteItem(basketId: string | null, itemId: number, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    getUpSellProducts(basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfListOfUpSellProductItemRelation> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/up-sell';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfListOfUpSellProductItemRelation>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/up-sell-' + cancellationContextKey : undefined);
    }
    replaceItem(basketId: string | null, request: ReplaceItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/replace';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getBasketInvoiceAddress(basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfBasketInvoiceAddress> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/invoice-address';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketInvoiceAddress>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/invoice-address-' + cancellationContextKey : undefined);
    }
    changeToPickAndPack(basketId: string | null, request: ChangeDeliveryTypeRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/change-to-pick-and-pack';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    changeToRegular(basketId: string | null, request: ChangeDeliveryTypeRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/change-to-regular';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    requisition(basketId: string | null, itemId: number, request: AddLineRequisitionRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/{itemId}/requisition';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addRequisitionAndComment(basketId: string | null, request: AddRequisitionAndCommentRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/requisition-comment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getEarliestAvailabilityDatesForBasket(basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfEarliestAvailabilityDatesForBasketResult> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/delivery/earliest-availability-dates';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEarliestAvailabilityDatesForBasketResult>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/delivery/earliest-availability-dates-' + cancellationContextKey : undefined);
    }
    getEarliestDeliveryDateForCustomerDelivery(basketId: string | null, deliveryId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfEarliestCustomerDeliveryDates> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/delivery/{deliveryId}/earliest-delivery-date';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEarliestCustomerDeliveryDates>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/delivery/{deliveryId}/earliest-delivery-date-' + cancellationContextKey : undefined);
    }
    getDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery(basketId: string | null, deliveryId: number, itemIds: number[], messageId?: string): Promise<ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/delivery/{deliveryId}/split/earliest-delivery-date';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery>(apiUrl, itemIds, messageId);
    }
    getDeliveryTimesForCustomerDelivery(basketId: string | null, deliveryId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfDeliveryTimesForCustomerDelivery> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/delivery/{deliveryId}/delivery-times/shipping';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDeliveryTimesForCustomerDelivery>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/delivery/{deliveryId}/delivery-times/shipping-' + cancellationContextKey : undefined);
    }
    getPickUpPointsForDelivery(basketId: string | null, deliveryId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPickUpPointsForDelivery> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/delivery/{deliveryId}/pickup-points';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPickUpPointsForDelivery>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/delivery/{deliveryId}/pickup-points-' + cancellationContextKey : undefined);
    }
    getPickUpTimesForCustomerDelivery(basketId: string | null, deliveryId: number, hubId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPickUpTimesForCustomerDelivery> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/delivery/{deliveryId}/delivery-times/pickup/{hubId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (hubId === undefined || hubId === null)
            throw new Error('The parameter "hubId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{hubId}', encodeURIComponent('' + hubId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPickUpTimesForCustomerDelivery>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/basket/{basketId}/delivery/{deliveryId}/delivery-times/pickup/{hubId}-' + cancellationContextKey : undefined);
    }
    getPickAndPackInventoryStatus(basketId: string | null, itemIds: number[], messageId?: string): Promise<ClientResponseOfPickAndPackInventoryResultOf> {
        let apiPathAndParams = '/api/b2b/basket/{basketId}/inventory/pick-and-pack-inventory';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPickAndPackInventoryResultOf>(apiUrl, itemIds, messageId);
    }
    getCustomersForAgent(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIEnumerableOfAgentCustomer> {
        let apiPathAndParams = '/api/b2b/agent/customers';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIEnumerableOfAgentCustomer>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/agent/customers-' + cancellationContextKey : undefined);
    }
    impersonateUserAsAgent(userIdToImpersonate: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfResponse> {
        let apiPathAndParams = '/api/b2b/agent/impersonate/{userIdToImpersonate}';
        if (userIdToImpersonate === undefined || userIdToImpersonate === null)
            throw new Error('The parameter "userIdToImpersonate" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{userIdToImpersonate}', encodeURIComponent('' + userIdToImpersonate));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/agent/impersonate/{userIdToImpersonate}-' + cancellationContextKey : undefined);
    }
    stopImpersonateUserAsAgent(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfStopImpersonationResponse> {
        let apiPathAndParams = '/api/b2b/agent/impersonate/stop';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfStopImpersonationResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/agent/impersonate/stop-' + cancellationContextKey : undefined);
    }
    login(request: LoginRequest, messageId?: string): Promise<ClientResponseOfLoginResponse> {
        let apiPathAndParams = '/api/b2b/authenticate/login';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfLoginResponse>(apiUrl, request, messageId);
    }
    refreshToken(refreshToken: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfRefreshTokenResponse> {
        let apiPathAndParams = '/api/b2b/authenticate/refresh-token/{refreshToken}';
        if (refreshToken === undefined || refreshToken === null)
            throw new Error('The parameter "refreshToken" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{refreshToken}', encodeURIComponent('' + refreshToken));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfRefreshTokenResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2b/authenticate/refresh-token/{refreshToken}-' + cancellationContextKey : undefined);
    }
}

export const B2BClientService = new B2BClient();

export interface ClientResponseOfRequestAccessResult {
    model: RequestAccessResult | undefined;
    messages: ClientMessage[];
}

export interface RequestAccessResult {
}

export interface ClientMessage {
    labelKey: string | undefined;
    message: string;
    messageType: ClientMessageType;
}

export enum ClientMessageType {
    Error = 0,
    Warning = 1,
    Info = 2,
}

export interface ClientResponse {
    messages: ClientMessage[];
}

export interface RequestAccessRequest {
    contactInfo: RequestAccessContactInfo;
    address: RequestAccessAddress;
    companyInfo: RequestAccessCompanyInfo;
    comments: string | undefined;
    storeId: string | undefined;
    recaptchaResponse: string;
}

export interface RequestAccessContactInfo {
    companyName: string | undefined;
    contactFirstName: string | undefined;
    contactLastName: string | undefined;
    contactPhone: string | undefined;
    contactEmail: string | undefined;
    website: string | undefined;
}

export interface RequestAccessAddress {
    street: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    countryCode: string;
}

export interface RequestAccessCompanyInfo {
    companyType: string | undefined;
    registrationNumber: string | undefined;
}

export interface ClientResponseOfPartnerProfileInformation {
    model: PartnerProfileInformation | undefined;
    messages: ClientMessage[];
}

export interface PartnerProfileInformation {
    partnerInformation: PartnerInformation;
    currentUser: PartnerUser;
}

export interface PartnerInformation {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    taxExemptNumber: string | undefined;
    registrationNumber: string | undefined;
    invoiceAddress: PartnerAddress | undefined;
    deliveryAddresses: PartnerAddress[] | undefined;
    deliveryTerms: string | undefined;
    paymentTerms: string | undefined;
}

export interface PartnerAddress {
    id: string;
    addressType: string;
    mainAddress: boolean;
    addressDescription: string | undefined;
    street: string;
    street2: string | undefined;
    zipCode: string;
    city: string;
    countryCode: CountryCode;
    country: string;
    website: string | undefined;
}

export interface CountryCode {
}

export interface PartnerUser {
    contactId: string;
    userId: string;
    name: string;
    userName: string;
    phone: string | undefined;
    role: B2BContactUserRole | undefined;
}

export enum B2BContactUserRole {
    B2BAdmin = 0,
    B2BSales = 1,
    B2BThirdParty = 3,
    B2BAgent = 99,
}

export interface ClientResponseOfExchangeRateModel {
    model: ExchangeRateModel | undefined;
    messages: ClientMessage[];
}

export interface ExchangeRateModel {
    exchangeRate: ExchangeRate | undefined;
    fromCurrency: CurrencyIsoCode;
    currencies: CurrencyIsoCode[];
}

export interface ExchangeRate {
    currency: CurrencyIsoCode | undefined;
    rate: number | undefined;
    enabled: boolean;
}

/** Currency codes as stated by the ISO 4217 standard */
export enum CurrencyIsoCode {
    ALL = 8,
    DZD = 12,
    ARS = 32,
    AUD = 36,
    BSD = 44,
    BHD = 48,
    BDT = 50,
    AMD = 51,
    BBD = 52,
    BMD = 60,
    BTN = 64,
    BOB = 68,
    BWP = 72,
    BZD = 84,
    SBD = 90,
    BND = 96,
    MMK = 104,
    BIF = 108,
    KHR = 116,
    CAD = 124,
    CVE = 132,
    KYD = 136,
    LKR = 144,
    CLP = 152,
    CNY = 156,
    COP = 170,
    KMF = 174,
    CRC = 188,
    HRK = 191,
    CUP = 192,
    CZK = 203,
    DKK = 208,
    DOP = 214,
    SVC = 222,
    ETB = 230,
    ERN = 232,
    EEK = 233,
    FKP = 238,
    FJD = 242,
    DJF = 262,
    GMD = 270,
    GIP = 292,
    GTQ = 320,
    GNF = 324,
    GYD = 328,
    HTG = 332,
    HNL = 340,
    HKD = 344,
    HUF = 348,
    ISK = 352,
    INR = 356,
    IDR = 360,
    IRR = 364,
    IQD = 368,
    ILS = 376,
    JMD = 388,
    JPY = 392,
    KZT = 398,
    JOD = 400,
    KES = 404,
    KPW = 408,
    KRW = 410,
    KWD = 414,
    KGS = 417,
    LAK = 418,
    LBP = 422,
    LSL = 426,
    LVL = 428,
    LRD = 430,
    LYD = 434,
    LTL = 440,
    MOP = 446,
    MWK = 454,
    MYR = 458,
    MVR = 462,
    MRO = 478,
    MUR = 480,
    MXN = 484,
    MNT = 496,
    MDL = 498,
    MAD = 504,
    OMR = 512,
    NAD = 516,
    NPR = 524,
    ANG = 532,
    AWG = 533,
    VUV = 548,
    NZD = 554,
    NIO = 558,
    NGN = 566,
    NOK = 578,
    PKR = 586,
    PAB = 590,
    PGK = 598,
    PYG = 600,
    PEN = 604,
    PHP = 608,
    QAR = 634,
    RUB = 643,
    RWF = 646,
    SHP = 654,
    STD = 678,
    SAR = 682,
    SCR = 690,
    SLL = 694,
    SGD = 702,
    VND = 704,
    SOS = 706,
    ZAR = 710,
    SSP = 728,
    SZL = 748,
    SEK = 752,
    CHF = 756,
    SYP = 760,
    THB = 764,
    TOP = 776,
    TTD = 780,
    AED = 784,
    TND = 788,
    UGX = 800,
    MKD = 807,
    EGP = 818,
    GBP = 826,
    TZS = 834,
    USD = 840,
    UYU = 858,
    UZS = 860,
    WST = 882,
    YER = 886,
    ZMK = 894,
    TWD = 901,
    UYW = 927,
    VES = 928,
    MRU = 929,
    STN = 930,
    CUC = 931,
    ZWL = 932,
    BYN = 933,
    TMT = 934,
    GHS = 936,
    VEF = 937,
    SDG = 938,
    UYI = 940,
    RSD = 941,
    MZN = 943,
    AZN = 944,
    RON = 946,
    CHE = 947,
    CHW = 948,
    TRY = 949,
    XAF = 950,
    XCD = 951,
    XOF = 952,
    XPF = 953,
    XBA = 955,
    XBB = 956,
    XBC = 957,
    XBD = 958,
    XAU = 959,
    XDR = 960,
    XAG = 961,
    XPT = 962,
    XTS = 963,
    XPD = 964,
    XUA = 965,
    ZMW = 967,
    SRD = 968,
    MGA = 969,
    COU = 970,
    AFN = 971,
    TJS = 972,
    AOA = 973,
    BYR = 974,
    BGN = 975,
    CDF = 976,
    BAM = 977,
    EUR = 978,
    MXV = 979,
    UAH = 980,
    GEL = 981,
    BOV = 984,
    PLN = 985,
    BRL = 986,
    CLF = 990,
    XSU = 994,
    USN = 997,
    USS = 998,
    XXX = 999,
}

export interface ClientResponseOfIEnumerableOfPartnerUser {
    model: PartnerUser[] | undefined;
    messages: ClientMessage[];
}

export interface B2BPasswordResetTokenRequest {
    requestSettings: string;
}

export interface ChangePasswordRequest {
    password: string;
    newPassword: string;
    passwordConfirmation: string;
}

export interface ClientResponseOfPartnerAddressOf {
    model: PartnerAddress[] | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfValidateTokenResult {
    model: ValidateTokenResult | undefined;
    messages: ClientMessage[];
}

export interface ValidateTokenResult {
    result: ValidateTokenResultType;
}

export enum ValidateTokenResultType {
    Ok = 0,
    InvalidToken = 1,
    UserDoesNotExist = 2,
    NoResetTokenForUser = 3,
    TokenExpired = 4,
}

export interface ChangePasswordFromTokenRequest {
    resetToken: string;
    password: string;
    passwordConfirmation: string;
}

export interface B2BResetPasswordTokenByUsernameRequest {
    userName: string;
    requestSettings: string;
}

export interface ValidateTokenRequest {
    resetToken: string;
}

export interface ClientResponseOfDictionaryOfStringAndProductPriceModel {
    model: { [key: string]: ProductPriceModel; } | undefined;
    messages: ClientMessage[];
}

export interface ProductPriceModel {
    listPrice: BoliaMoney;
    salesPrice: BoliaMoney;
    ecoTaxPrice: BoliaMoney | undefined;
    discount: ProductBaseDiscount | undefined;
    priceValidUntil: Date | undefined;
}

export interface BoliaMoney {
    rawAmount: number;
    amount: string;
    currency: string;
}

export interface ProductBaseDiscount {
    type: ProductDiscountType;
    discount: BoliaMoney;
    percentage: number;
    expiryLabel: LabelWithNamedArguments | undefined;
    discriminator: string;
}

export enum ProductDiscountType {
    Campaign = 0,
    MyBoliaBoost = 1,
}

export interface LabelWithNamedArguments {
    label: string;
    severity: LabelSeverity;
    namedParams: { [key: string]: any; };
}

export enum LabelSeverity {
    Error = 0,
    Warning = 1,
    Information = 2,
}

export interface ProductCampaignDiscount extends ProductBaseDiscount {
}

export interface ProductMyBoliaBoostDiscount extends ProductBaseDiscount {
}

export interface ClientResponseOfProductPriceModel {
    model: ProductPriceModel | undefined;
    messages: ClientMessage[];
}

export interface Module {
    sku: string;
    quantity: number;
}

export interface ClientResponseOfPaginatedResult {
    model: PaginatedResult | undefined;
    messages: ClientMessage[];
}

export interface PaginatedResult {
    totalResults: number;
    totalPages: number;
    currentPage: number;
    orders: OrderHeader[];
}

export interface OrderHeader {
    orderNumber: string;
    orderDate: Date;
    status: SalesStatus;
    requisitions: string[];
    shipmentDate: Date | undefined;
    totalAmount: string;
    confirmationDocumentDownloadLink: string | undefined;
    invoices: Invoice[];
}

export enum SalesStatus {
    Open = 0,
    BackOrder = 1,
    Delivered = 2,
    Invoiced = 3,
    Cancelled = 4,
    PartiallyInvoiced = 5,
}

export interface Invoice {
    id: string;
    documentDownloadLink: string | undefined;
    totalAmount: string;
    shipmentDate: Date | undefined;
}

export enum FilterSalesStatus {
    Open = 0,
    Invoiced = 3,
    Cancelled = 4,
    PartiallyInvoiced = 5,
}

export interface ClientResponseOfOrder {
    model: Order | undefined;
    messages: ClientMessage[];
}

export interface Order {
    orderNumber: string;
    invoiceAddress: Address | undefined;
    deliveryAddress: Address | undefined;
    orderDate: Date;
    requisition: string | undefined;
    status: SalesStatus;
    comment: string | undefined;
    confirmationDocumentDownloadLink: string | undefined;
    totalAmount: string;
    totalDiscount: string | undefined;
    invoices: Invoice[];
    creditNotes: Invoice[];
    orderLines: OrderLine[];
    serviceLines: ServiceLine[];
}

export interface Address {
    name: string | undefined;
    street: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    country: string | undefined;
}

export interface OrderLine {
    id: string;
    itemId: string;
    description: string;
    variant: Variant | undefined;
    quantity: number;
    itemNetPrice: string;
    totalPrice: string;
    totalDiscount: OrderLineDiscount | undefined;
    shippingDate: Date | undefined;
    lineNum: number;
    salesHistory: SalesHistory;
    salesStatus: SalesStatus;
    trackAndTraceLinks: string[] | undefined;
    requisition: string | undefined;
    isClaimable: boolean;
    claimableType: ClaimableType | undefined;
}

export interface Variant {
    name: string;
    itemNumber: string;
    sku: string;
    quantityMultiplier: number;
    productLifeCycle: ProductLifeCycle;
    specifications: SpecificationAttribute[] | undefined;
    basketSpecifications: SpecificationAttribute[] | undefined;
    productInformation: ProductInformation;
    collis: Colli[] | undefined;
    isWithinRequestedAssortment: boolean;
    imageVersion: number;
    isDiscontinued: boolean;
}

export enum ProductLifeCycle {
    Unknown = "Unknown",
    Created = "Created",
    PreReleased = "PreReleased",
    Released = "Released",
    Outgoing = "Outgoing",
    Discontinued = "Discontinued",
    Closed = "Closed",
    Construction = "Construction",
    OutletOnly = "OutletOnly",
    OutgoingCons = "OutgoingCons",
    B2BOnly = "B2BOnly",
}

export interface SpecificationAttribute {
    name: string;
    label: string;
    value: string;
}

export interface ProductInformation {
    ean: string | undefined;
    listItems: ProductVariantsSpecificationAttributes | undefined;
    assemblyGuideUrl: string | undefined;
    careGuideUrl: string | undefined;
    lightingUrl: string | undefined;
    userManualUrl: string | undefined;
    productFactSheetTemplate: string | undefined;
    warningUrl: string | undefined;
}

export interface ProductVariantsSpecificationAttributes {
    variantSpecifications: SpecificationAttribute[] | undefined;
    productLocalizedSpecifications: SpecificationAttribute[] | undefined;
}

export interface Colli {
    id: string;
    number: number;
    unitVolume: number;
    height: number;
    width: number;
    depth: number;
    grossWeight: number;
}

export interface OrderLineDiscount {
    percentage: number;
    amount: string;
}

export enum SalesHistory {
    Normal = 0,
    Replaced = 2,
}

export enum ClaimableType {
    Product = 0,
    Freight = 1,
}

export interface ServiceLine {
    id: string;
    itemId: string;
    description: string;
    quantity: number;
    itemNetPrice: string;
    totalPrice: string;
    totalDiscount: OrderLineDiscount | undefined;
    shippingDate: Date | undefined;
    lineNum: number;
    salesHistory: SalesHistory;
    salesStatus: SalesStatus;
    isClaimable: boolean;
    claimableType: ClaimableType | undefined;
}

export interface ClientResponseOfGetTransactionsResponse {
    model: GetTransactionsResponse | undefined;
    messages: ClientMessage[];
}

export interface GetTransactionsResponse {
    transactions: Transaction[] | undefined;
    totalNumberOfPages: number;
}

export interface Transaction {
    transactionType: TransactionType;
    requisitionStatus: TransactionStatus;
    orderNumber: string | undefined;
    transactionDate: Date;
    dueDate: Date | undefined;
    invoiceNumber: string | undefined;
    requisitions: string[];
    description: string | undefined;
    amount: string;
    pdfDownloadUrl: string | undefined;
    isPdfDocumentAvailable: boolean;
}

export enum TransactionType {
    Invoice = 0,
    CreditNote = 1,
    Sales = 2,
    Customer = 8,
    Payment = 15,
    Settlement = 24,
    GeneralJournal = 36,
}

export enum TransactionStatus {
    Open = 0,
    Closed = 1,
}

export enum OrderByDirection {
    Asc = 0,
    Desc = 1,
}

export interface ClientResponseOfPartnerBalance {
    model: PartnerBalance | undefined;
    messages: ClientMessage[];
}

export interface PartnerBalance {
    creditLimit: string;
    balance: string;
    creditRemaining: string;
}

export interface ClientResponseOfIEnumerableOfFavorite {
    model: Favorite[] | undefined;
    messages: ClientMessage[];
}

export interface Favorite {
    id: number;
    name: string;
    shared: boolean;
    createDateTime: Date;
    createdBy: string;
    numberOfProducts: number;
    skus: VariantImageVersion[] | undefined;
    favoriteItems: FavoriteItem[];
    shareIdentifier: string;
    isCreatedByCurrentUser: boolean;
    recommendedRetailPriceTotal: Price | undefined;
    netPriceTotal: Price | undefined;
    purchasableProducts: string[];
}

export interface VariantImageVersion {
    sku: string;
    imageVersion: number;
}

export interface FavoriteItem {
    id: number;
    variant: Variant;
    quantity: number;
    netPrice: Price | undefined;
    recommendedRetailPrice: Price | undefined;
    ecoTax: Price | undefined;
    netPriceTotal: Price | undefined;
    recommendedRetailPriceTotal: Price | undefined;
}

export interface Price {
    amount: string;
    amountWithDecimals: string;
    discount: Discount | undefined;
    amountAfterDiscount: string;
}

export interface Discount {
    percentage: number;
    amount: string;
    rawAmount: number;
}

export interface CreateFavoriteRequest {
    name: string;
    shared: boolean;
}

export interface ClientResponseOfFavorite {
    model: Favorite | undefined;
    messages: ClientMessage[];
}

export interface UpdateFavoriteRequest {
    name: string;
    shared: boolean;
}

export interface CreateFavoriteItemRequest {
    sku: string;
}

export interface Request {
    quantity: number;
}

export interface ClientResponseOfIEnumerableOfFavoriteItemAvailabilityDate {
    model: FavoriteItemAvailabilityDate[] | undefined;
    messages: ClientMessage[];
}

export interface FavoriteItemAvailabilityDate {
    id: number;
    date: Date;
    type: AvailabilityDateType;
}

export enum AvailabilityDateType {
    Delivery = 0,
    Pickup = 1,
    DeliveryOrPickup = 2,
}

export interface ClientResponseOfSharedFavorite {
    model: SharedFavorite | undefined;
    messages: ClientMessage[];
}

export interface SharedFavorite {
    name: string;
    createdBy: string | undefined;
    favoriteItems: FavoriteItem[];
    numberOfProducts: number;
    recommendedRetailPriceTotal: Price | undefined;
}

export interface ClientResponseOfUploadClaimFormFileResponse {
    model: UploadClaimFormFileResponse | undefined;
    messages: ClientMessage[];
}

export interface UploadClaimFormFileResponse {
    claimFormFileId: string;
}

export interface CreateClaimsRequest {
    queue: string;
    orderNumber: string;
    contactDetails: ContactDetails;
    claims: ClaimDetails[];
}

export interface ContactDetails {
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
}

export interface ClaimDetails {
    itemId: string;
    productName: string;
    productSku: string;
    issue: ClaimFormIssue;
    claimFileIds: string[];
    grouped: boolean;
    claimableType: ClaimableType;
}

export interface ClaimFormIssue {
    code: string;
    category: string;
    description: string | undefined;
}

export interface ClientResponseOfPaymentInitializeResult {
    model: PaymentInitializeResult | undefined;
    messages: ClientMessage[];
}

export interface PaymentInitializeResult {
    itemsOutOfStock: number[] | undefined;
}

export interface ClientResponseOfPaymentFinalizeResult {
    model: PaymentFinalizeResult | undefined;
    messages: ClientMessage[];
}

export interface PaymentFinalizeResult {
    orderNumber: string;
}

export interface ClientResponseOfAltaPayPaymentInitializeResult {
    model: AltaPayPaymentInitializeResult | undefined;
    messages: ClientMessage[];
}

export interface AltaPayPaymentInitializeResult {
    sessionId: string;
    token: string;
}

export interface InitializeAltaPayPaymentRequest {
    shopName: string | undefined;
}

export interface FinalizeAltaPayPaymentRequest {
    paymentId: string;
    orderNumber: string;
    subscribeNewsletter: boolean;
}

export interface ClientResponseOfBasketCheckoutModel {
    model: BasketCheckoutModel | undefined;
    messages: ClientMessage[];
}

export interface BasketCheckoutModel {
    basketId: string;
    invoiceAddress: BasketInvoiceAddress | undefined;
    items: BaseProductItem[];
    summary: BasketCheckoutModelSummary;
    paymentOptions: PaymentOption[];
    deliverables: CheckOutDeliverable[];
    hasSufficientPayments: boolean;
}

export interface BasketInvoiceAddress {
    buyer: BasketBuyer | undefined;
    address: BasketAddress | undefined;
    buyerContactInformation: BasketBuyerContactInformation | undefined;
    signUpNewsLetter: boolean;
}

export interface BasketBuyer {
    firstName: string;
    lastName: string;
    vatNumber: string | undefined;
    companyName: string | undefined;
}

export interface BasketAddress {
    street: string;
    street2: string | undefined;
    postalCode: string;
    id: string;
    unknownPostalCode: boolean;
    city: string;
    countryCode: string;
    country: string;
    otherCountryName: string | undefined;
    hasLift: boolean;
    addressDescription: string | undefined;
}

export interface BasketBuyerContactInformation {
    emailAddress: string;
    phoneNumber: string | undefined;
    alternateNumber: string | undefined;
}

export interface BaseItem {
    id: number;
    created: Date;
    lastModified: Date;
    uniqueIdentifier: string;
    primaryItemMessages: ItemMessage[];
    secondaryItemMessages: ItemMessage[];
    type: ItemType;
    discriminator: string;
}

export interface BaseProductItem extends BaseItem {
    sku: string;
    name: string;
    quantity: number;
    quantityMultiplier: number;
    isDiscontinued: boolean;
    isSoldOut: boolean;
    imageVersion: number;
    price: ProductItemPrice | undefined;
    specifications: SpecificationAttribute[] | undefined;
    metaData: ProductMetaData | undefined;
    requisition: string | undefined;
    discriminator: string;
}

export interface ProductItemPrice {
    listPrice: BoliaMoney | undefined;
    listPriceTotal: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    discounts: BaseDiscount[] | undefined;
    rrpPrice: BoliaMoney | undefined;
    rrPriceTotal: BoliaMoney | undefined;
}

export interface BaseDiscount {
    type: DiscountType;
    percentage: number;
    discount: BoliaMoney;
    discountTotal: BoliaMoney;
    discriminator: string;
}

export enum DiscountType {
    Campaign = 1,
}

export interface CampaignDiscount extends BaseDiscount {
    offerId: string;
    offerName: string;
}

export interface ProductMetaData {
    family: string | undefined;
    retailHierarchy: string | undefined;
    businessArea: string | undefined;
    brand: string | undefined;
    ean: string | undefined;
}

export interface ItemMessage extends LabelWithNamedArguments {
    type: ItemMessageType;
}

export enum ItemMessageType {
    Default = 0,
    Basket = 1,
    CheckOut = 2,
}

export enum ItemType {
    Regular = 1,
    PickAndPack = 2,
    ModuleSofa = 3,
    ModuleSofaItem = 4,
    ModuleConfiguration = 5,
    ModuleConfigurationItem = 6,
}

export interface RegularProductItem extends BaseProductItem {
    changeToPickAndPackDeliveryEnabled: boolean;
}

export interface PickAndPackProductItem extends BaseProductItem {
    changeToCustomerDeliveryEnabled: boolean;
    inventoryStatus: InventoryStatus | undefined;
}

export interface InventoryStatus {
    totalAvailable: number;
    reservedByUser: number;
    remainingAvailable: number;
}

export interface ModuleSofaConfigurationProductItem extends BaseProductItem {
    modules: ModuleSofaProductItem[];
    modulesConnections: BasketModuleSofaItem[];
    specification: BasketModuleSofaSpecification | undefined;
    image: string | undefined;
    moduleReferenceId: string | undefined;
}

export interface ModuleSofaProductItem extends BaseProductItem {
}

export interface BasketModuleSofaItem {
    sku: string;
    connections: ModuleSofaConnection;
}

export interface ModuleSofaConnection {
    a: string;
    b: string;
    c: string;
    d: string;
}

export interface BasketModuleSofaSpecification {
    name: string;
    image: string;
    width: number;
    height: number;
}

export interface ModuleConfigurationProductItem extends BaseProductItem {
    modules: ModuleProductItem[];
    image: string | undefined;
    moduleReferenceId: string | undefined;
    moduleConfigurationSpecification: ModuleConfigurationSpecification | undefined;
}

export interface ModuleProductItem extends BaseProductItem {
}

export interface ModuleConfigurationSpecification {
    depth: number;
    height: number;
    width: number;
}

export interface BasketCheckoutModelSummary {
    expressFreightPriceTotal: BoliaMoney | undefined;
    rrpPriceTotal: BoliaMoney | undefined;
    listPriceTotal: BoliaMoney | undefined;
    discountTotal: BoliaMoney | undefined;
    salesPriceSubTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    rrpSalesTax: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    remainingToBePaid: BoliaMoney | undefined;
    showFreightPriceTotal: boolean;
}

export interface PaymentOption {
    type: PaymentOptionType;
}

export enum PaymentOptionType {
    Online = 0,
    BankTransfer = 1,
}

export interface CheckOutDeliverable {
    id: number;
    type: CheckoutDeliverableType;
    itemIds: number[];
    isValid: boolean;
    discriminator: string;
}

export enum CheckoutDeliverableType {
    CustomerDelivery = 0,
    PickUp = 1,
    PickAndPack = 2,
}

export interface CheckOutDeliverableWithAddress extends CheckOutDeliverable {
    deliveryAddress: BasketDeliveryAddress | undefined;
    canChangeDeliveryAddress: boolean;
}

export interface BasketDeliveryAddress {
    address: BasketAddress | undefined;
    buyer: BasketBuyer | undefined;
}

export interface CustomerDeliveryCheckOutDeliverable extends CheckOutDeliverableWithAddress {
    deliveryType: DeliveryType | undefined;
    deliveryTimeId: number | undefined;
    selectedPickupPoint: string | undefined;
    freight: FreightModel | undefined;
    generalTermsAndConditions: string | undefined;
    isDeliveryDisabled: boolean;
    isPickupDisabled: boolean;
}

export enum DeliveryType {
    Shipping = 1,
    PickUp = 2,
    Manual = 99,
}

export interface FreightModel {
    price: BoliaMoney | undefined;
    errorGettingPrice: boolean;
}

export interface PickAndPackCheckOutDeliverable extends CheckOutDeliverableWithAddress {
    text: LabelWithNamedArguments;
}

export interface SetDeliveryTimeRequest {
    deliveryType: DeliveryType;
    requestedDeliveryType: DeliveryType | undefined;
    postalCode: string;
    inventoryLocationId: string | undefined;
    deliveryTime: BasketDeliveryTime | undefined;
}

export interface BasketDeliveryTime {
    deliveryTimeId: number;
    deliveryDate: Date;
    startTime: Date;
    endTime: Date;
    modeOfDelivery: string;
}

export interface ClientResponseOfBasketModel {
    model: BasketModel | undefined;
    messages: ClientMessage[];
}

export interface BasketModel {
    basketId: string;
    retailChannelId: string;
    numberOfItems: number;
    deliverables: BasketDeliverable[];
    summary: BasketModelSummary;
    isCheckoutAble: boolean;
    created: Date;
    lastModified: Date;
    upSellItemCounter: number;
    pickAndPackDeliveryMaximumQuantity: number;
    pickAndPackDeliveryQuantityLeft: number;
    requisitionAndComment: RequisitionAndCommentModel | undefined;
}

export interface BasketDeliverable {
    type: CheckoutDeliverableType;
    items: BaseItem[];
    discriminator: string;
}

export interface BasketDeliverableForPickAndPack extends BasketDeliverable {
    changeToCustomerDeliveryEnabled: boolean;
    text: LabelWithNamedArguments;
}

export interface BasketDeliverableForCustomerDelivery extends BasketDeliverable {
    changeToPickAndDeliveryEnabled: boolean;
    isPickupDisabled: boolean;
}

export interface BasketModelSummary {
    listPriceTotal: BoliaMoney | undefined;
    discountTotal: BoliaMoney | undefined;
    salesPriceSubTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    salesTax: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    remainingToBePaid: BoliaMoney | undefined;
    expressFreightPriceTotal: BoliaMoney | undefined;
    rrpPriceTotal: BoliaMoney | undefined;
    showFreightPriceTotal: boolean;
}

export interface RequisitionAndCommentModel {
    requisition: string | undefined;
    comment: string | undefined;
}

export interface AddBasketItemRequest {
    sku: string;
    quantity: number;
    relatedItemId: number | undefined;
    delta: boolean | undefined;
}

export interface AddModuleSofaRequest {
    specification: BasketModuleSofaSpecification;
    modules: BasketModuleSofaItem[];
}

export interface ClientResponseOfModuleSofaConfigurationProductItem {
    model: ModuleSofaConfigurationProductItem | undefined;
    messages: ClientMessage[];
}

export interface AddOrUpdateModuleConfigurationRequest {
    configuration: ModuleConfiguration;
    modules: ModuleConfigurationItem[];
}

export interface ModuleConfiguration {
    name: string;
    depth: number;
    height: number;
    width: number;
    image: string;
}

export interface ModuleConfigurationItem {
    sku: string;
    quantity: number;
}

export interface UpdateItemQuantityRequest {
    quantity: number;
    delta: boolean;
}

export interface ClientResponseOfListOfUpSellProductItemRelation {
    model: UpSellProductItemRelation[] | undefined;
    messages: ClientMessage[];
}

export interface UpSellProductItemRelation {
    items: UpSellItemInBasket[];
    sku: string | undefined;
}

export interface UpSellItemInBasket {
    itemId: number;
    isInBasket: boolean;
}

export interface ReplaceItemRequest {
    lineItemId: string;
    targetSku: string;
}

export interface ClientResponseOfBasketInvoiceAddress {
    model: BasketInvoiceAddress | undefined;
    messages: ClientMessage[];
}

export interface ChangeDeliveryTypeRequest {
    itemIds: number[];
}

export interface AddLineRequisitionRequest {
    requisition: string | undefined;
}

export interface AddRequisitionAndCommentRequest {
    requisition: string | undefined;
    comment: string | undefined;
}

export interface ClientResponseOfEarliestAvailabilityDatesForBasketResult {
    model: EarliestAvailabilityDatesForBasketResult | undefined;
    messages: ClientMessage[];
}

export interface EarliestAvailabilityDatesForBasketResult {
    itemMessages: EarliestAvailabilityDateItemMessage[] | undefined;
}

export interface EarliestAvailabilityDateItemMessage {
    itemId: number;
    itemMessage: ItemMessage;
}

export interface ClientResponseOfEarliestCustomerDeliveryDates {
    model: EarliestCustomerDeliveryDates | undefined;
    messages: ClientMessage[];
}

export interface EarliestCustomerDeliveryDates {
    labelForItems: LabelForItem[] | undefined;
    generalLabel: LabelWithNamedArguments;
    canBeSplit: boolean;
    canRemoveSplit: boolean;
    shouldBeSplit: boolean;
    canBeDelivered: boolean;
    canUndoSplit: boolean;
}

export interface LabelForItem {
    itemId: number;
    label: LabelWithNamedArguments;
}

export interface ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery {
    model: DeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface DeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery {
    text: LabelWithNamedArguments;
}

export interface ClientResponseOfDeliveryTimesForCustomerDelivery {
    model: DeliveryTimesForCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface DeliveryTimesForCustomerDelivery {
    message: LabelWithNamedArguments | undefined;
    deliveryTimeSlotModel: DeliveryTimeSlotModel | undefined;
}

export interface DeliveryTimeSlotModel {
    deliveryType: DeliveryType;
    postalCode: string;
    inventoryLocationId: string;
    deliverySlots: DeliverySlot[] | undefined;
    requestedDeliveryType: DeliveryType | undefined;
}

export interface DeliverySlot {
    startTime: Date;
    endTime: Date;
    deliveryDate: Date;
    deliveryTimeId: number;
    modeOfDelivery: string;
    formattedDeliveryDate: string;
}

export interface ClientResponseOfPickUpPointsForDelivery {
    model: PickUpPointsForDelivery | undefined;
    messages: ClientMessage[];
}

export interface PickUpPointsForDelivery {
    defaultPickUpId: string | undefined;
    hubs: HubModel[];
}

export interface HubModel {
    id: string;
    name: string;
    street: string;
    zipCode: string;
    city: string;
    countryCode: string;
    countryName: string;
    latitude: number;
    longitude: number;
    isPickUpPoint: boolean;
}

export interface ClientResponseOfPickUpTimesForCustomerDelivery {
    model: PickUpTimesForCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface PickUpTimesForCustomerDelivery {
    message: LabelWithNamedArguments | undefined;
    deliveryTimeSlotModel: DeliveryTimeSlotModel | undefined;
}

export interface ClientResponseOfPickAndPackInventoryResultOf {
    model: PickAndPackInventoryResult[] | undefined;
    messages: ClientMessage[];
}

export interface PickAndPackInventoryResult {
    itemId: number;
    canBePickAndPackDelivered: boolean;
}

export interface ClientResponseOfIEnumerableOfAgentCustomer {
    model: AgentCustomer[] | undefined;
    messages: ClientMessage[];
}

export interface AgentCustomer {
    accountId: string | undefined;
    d365AccountId: string | undefined;
    name: string | undefined;
    address: PartnerAddress | undefined;
    impersonateUserId: string | undefined;
}

export interface ClientResponseOfResponse {
    model: Response | undefined;
    messages: ClientMessage[];
}

export interface Response {
    accessToken: string;
}

export interface ClientResponseOfStopImpersonationResponse {
    model: StopImpersonationResponse | undefined;
    messages: ClientMessage[];
}

export interface StopImpersonationResponse {
    success: boolean;
    token: string;
    refreshToken: string;
    redirectUrl: string;
}

export interface ClientResponseOfLoginResponse {
    model: LoginResponse | undefined;
    messages: ClientMessage[];
}

export interface LoginResponse {
    success: boolean;
    token: string;
    refreshToken: string;
}

export interface LoginRequest {
    userName: string;
    password: string;
}

export interface ClientResponseOfRefreshTokenResponse {
    model: RefreshTokenResponse | undefined;
    messages: ClientMessage[];
}

export interface RefreshTokenResponse {
    success: boolean;
    token: string;
    refreshToken: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}